// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const MenuCloseHover: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 21 20"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="21"
            height="20"
            fill="currentColor"
        >
            <path
                d="M752.652247,193.645788 L734.854212,175.847753 C734.407412,175.400954 734.379551,174.704411 734.791981,174.291981 C735.204411,173.879551 735.900954,173.907412 736.347753,174.354212 L754.145788,192.152247 C754.592588,192.599046 754.620449,193.295589 754.208019,193.708019 C753.795589,194.120449 753.099046,194.092588 752.652247,193.645788 Z M754.145788,175.847753 L736.347753,193.645788 C735.900954,194.092588 735.204411,194.120449 734.791981,193.708019 C734.379551,193.295589 734.407412,192.599046 734.854212,192.152247 L752.652247,174.354212 C753.099046,173.907412 753.795589,173.879551 754.208019,174.291981 C754.620449,174.704411 754.592588,175.400954 754.145788,175.847753 Z"
                transform="translate(-734 -174)"
            />
        </svg>
    );
};

export default React.memo(MenuCloseHover);
